const DEFAULT_PREVIEW_LIMIT = 3;

const isValidPositiveIndex = (value) => Number.isFinite(value) && value >= 0;

const getSetCount = (exercise) =>
  Array.isArray(exercise?.series) ? exercise.series.length : 0;

const getExerciseName = ({ exercise, t, language }) => {
  if (exercise?.getName && typeof exercise.getName === "function") {
    try {
      const translatedName = exercise.getName(t, language);
      if (typeof translatedName === "string" && translatedName.trim()) {
        return translatedName;
      }
    } catch (_error) {
      // Fallback to raw names if translation helper fails.
    }
  }

  if (typeof exercise?.name === "string" && exercise.name.trim()) {
    return exercise.name;
  }

  if (
    typeof exercise?.originalName === "string" &&
    exercise.originalName.trim()
  ) {
    return exercise.originalName;
  }

  return "";
};

const sortExercisesForPreview = (exercises) =>
  exercises
    .map((exercise, index) => ({ exercise, index }))
    .sort((a, b) => {
      const aOrder = a.exercise?.order;
      const bOrder = b.exercise?.order;
      const aHasOrder = isValidPositiveIndex(aOrder);
      const bHasOrder = isValidPositiveIndex(bOrder);

      if (aHasOrder && bHasOrder && aOrder !== bOrder) {
        return aOrder - bOrder;
      }
      if (aHasOrder && !bHasOrder) return -1;
      if (!aHasOrder && bHasOrder) return 1;
      return a.index - b.index;
    })
    .map((item) => item.exercise);

export const getWorkoutRowPreviewData = ({
  workout,
  t,
  language,
  previewLimit = DEFAULT_PREVIEW_LIMIT,
}) => {
  const safePreviewLimit =
    Number.isFinite(previewLimit) && previewLimit > 0
      ? Math.floor(previewLimit)
      : DEFAULT_PREVIEW_LIMIT;
  const allExercises = Array.isArray(workout?.exercises)
    ? sortExercisesForPreview(workout.exercises)
    : [];
  const previewExercises = allExercises.slice(0, safePreviewLimit);
  const remainingCount = Math.max(0, allExercises.length - previewExercises.length);
  const translate = typeof t === "function" ? t : (key) => key;

  const rows = previewExercises.map((exercise, index) => {
    const setCount = getSetCount(exercise);
    return {
      id: exercise?.id ?? `preview-${index}`,
      name: getExerciseName({ exercise, t, language }),
      setCount,
      setsLabel:
        setCount === 1
          ? translate("setSingular-string")
          : translate("sets-string"),
    };
  });

  return {
    rows,
    remainingCount,
    totalExercises: allExercises.length,
  };
};
